import React, { ReactElement } from 'react';
import type { StageIconPickerProps } from './types';
import { StandardStageIconPicker } from './presentational';

export type { StageIconPickerProps } from './types';
export { getStageIconComponent } from '../StageIcon';

export function StageIconPicker(props: StageIconPickerProps): ReactElement {
  return (
    <StandardStageIconPicker
      value={props.value}
      onChange={props.onChange}
      stageNumber={props.stageNumber}
      disabled={props.disabled}
      fullWidth={props.fullWidth}
    />
  );
}
